const MODAL_WIDTH = 600
const TITLE = 'What can I say?'

const AMWELL = 'AMWELL'
const GENERAL = 'GENERAL'
const NOTE = 'NOTE'

const CASE_TYPES = {
  AMWELL,
  GENERAL,
  NOTE
}

export { MODAL_WIDTH, TITLE, CASE_TYPES }
